// extracted by mini-css-extract-plugin
module.exports = {"label":"inputNumberProjectPage_label__2PDu1","input":"inputNumberProjectPage_input__hQ_SX"};
    if(module.hot) {
      // 1790670320686
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  